// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimized Modal - Fixed at bottom right */
.video-generation-modal.minimized {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  width: 320px;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  color: #fff;
}

.minimized-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.minimized-info {
  flex: 1 1;
  min-width: 0;
}

.minimized-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.minimized-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-bar-mini {
  flex: 1 1;
  height: 4px;
  background: #333;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill-mini {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.progress-text-mini {
  font-size: 12px;
  color: #ccc;
  font-weight: 500;
  min-width: 35px;
  text-align: right;
}

.minimized-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
}

.expand-button, .close-button-mini {
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.expand-button:hover, .close-button-mini:hover {
  color: #fff;
  background: #333;
}

/* Expanded Modal */
.video-generation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10001;
}

.video-generation-modal.expanded {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #333;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.modal-header-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.minimize-button, .close-button {
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.minimize-button:hover, .close-button:hover {
  color: #fff;
  background: #333;
}

.modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

/* Project Info Section */
.project-info {
  text-align: center;
  margin-bottom: 24px;
}

.project-info h4 {
  margin: 0 0 12px 0;
  font-size: 18px;
  color: #fff;
}

.status-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.status-indicator {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.time-remaining {
  font-size: 14px;
  color: #ccc;
}

/* Progress Section */
.progress-section {
  margin-bottom: 24px;
}

.progress-bar {
  height: 8px;
  background: #333;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-percentage {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.progress-status {
  font-size: 14px;
  color: #ccc;
}

/* Success Section */
.success-section {
  text-align: center;
}

.success-icon {
  margin-bottom: 16px;
}

.success-icon svg {
  color: #28a745;
}

.success-section p {
  font-size: 16px;
  color: #ccc;
  margin-bottom: 20px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.download-button, .view-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
}

.download-button {
  background: #28a745;
  color: white;
}

.download-button:hover {
  background: #218838;
  color: white;
  text-decoration: none;
}

.view-button {
  background: #007acc;
  color: white;
}

.view-button:hover {
  background: #005a9e;
}

/* Error Section */
.error-section {
  text-align: center;
}

.error-icon {
  margin-bottom: 16px;
}

.error-icon svg {
  color: #dc3545;
}

.error-section p {
  font-size: 16px;
  color: #dc3545;
  margin-bottom: 12px;
}

.error-message {
  background: #2a1a1a;
  border: 1px solid #dc3545;
  border-radius: 6px;
  padding: 12px;
  color: #ccc;
  font-size: 14px;
  margin-bottom: 20px;
}

.retry-button {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.retry-button:hover {
  background: #c82333;
}

/* Processing Animation */
.processing-animation {
  text-align: center;
  margin-top: 20px;
}

.processing-animation .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #333;
  border-top: 3px solid #007acc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.processing-animation p {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 12px 0;
}

.generation-notice {
  background: #2a1a1a;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 12px;
  margin-top: 16px;
}

.generation-notice p {
  font-size: 12px;
  color: #ffeb3b;
  margin: 0;
  line-height: 1.4;
}

/* Download Notification */
.download-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10003;
  max-width: 300px;
  background: #1a2a1a;
  border: 1px solid #28a745;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
}

.notification-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.notification-icon svg {
  color: #28a745;
}

.notification-text {
  flex: 1 1;
  min-width: 0;
}

.notification-text strong {
  color: #28a745;
  font-size: 14px;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.notification-text p {
  margin: 0;
  font-size: 13px;
  color: #ccc;
  line-height: 1.3;
}

.notification-close {
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: all 0.2s;
}

.notification-close:hover {
  color: #fff;
  background: #333;
}

/* Responsive */
@media (max-width: 600px) {
  .video-generation-modal.minimized {
    width: calc(100vw - 40px);
    right: 20px;
  }
  
  .video-generation-modal.expanded {
    width: 95%;
    max-height: 90vh;
  }
  
  .modal-content {
    padding: 20px 16px;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: stretch;
  }
  
  .download-notification {
    right: 10px;
    left: 10px;
    max-width: none;
  }
  
  .minimized-title {
    font-size: 12px;
  }
  
  .progress-text-mini {
    font-size: 11px;
    min-width: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoGenerationModal.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":["/* Minimized Modal - Fixed at bottom right */\n.video-generation-modal.minimized {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 10000;\n  width: 320px;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.minimized-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n}\n\n.minimized-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.minimized-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 6px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.minimized-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.progress-bar-mini {\n  flex: 1;\n  height: 4px;\n  background: #333;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.progress-fill-mini {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.progress-text-mini {\n  font-size: 12px;\n  color: #ccc;\n  font-weight: 500;\n  min-width: 35px;\n  text-align: right;\n}\n\n.minimized-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.expand-button, .close-button-mini {\n  background: none;\n  border: none;\n  color: #ccc;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.expand-button:hover, .close-button-mini:hover {\n  color: #fff;\n  background: #333;\n}\n\n/* Expanded Modal */\n.video-generation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10001;\n}\n\n.video-generation-modal.expanded {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10002;\n  width: 90%;\n  max-width: 500px;\n  max-height: 80vh;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n  color: #fff;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #333;\n  flex-shrink: 0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.modal-header-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.minimize-button, .close-button {\n  background: none;\n  border: none;\n  color: #ccc;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.minimize-button:hover, .close-button:hover {\n  color: #fff;\n  background: #333;\n}\n\n.modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* Project Info Section */\n.project-info {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.project-info h4 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  color: #fff;\n}\n\n.status-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.status-indicator {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.time-remaining {\n  font-size: 14px;\n  color: #ccc;\n}\n\n/* Progress Section */\n.progress-section {\n  margin-bottom: 24px;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #333;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.progress-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.progress-percentage {\n  font-size: 18px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.progress-status {\n  font-size: 14px;\n  color: #ccc;\n}\n\n/* Success Section */\n.success-section {\n  text-align: center;\n}\n\n.success-icon {\n  margin-bottom: 16px;\n}\n\n.success-icon svg {\n  color: #28a745;\n}\n\n.success-section p {\n  font-size: 16px;\n  color: #ccc;\n  margin-bottom: 20px;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.download-button, .view-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 6px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: none;\n  cursor: pointer;\n}\n\n.download-button {\n  background: #28a745;\n  color: white;\n}\n\n.download-button:hover {\n  background: #218838;\n  color: white;\n  text-decoration: none;\n}\n\n.view-button {\n  background: #007acc;\n  color: white;\n}\n\n.view-button:hover {\n  background: #005a9e;\n}\n\n/* Error Section */\n.error-section {\n  text-align: center;\n}\n\n.error-icon {\n  margin-bottom: 16px;\n}\n\n.error-icon svg {\n  color: #dc3545;\n}\n\n.error-section p {\n  font-size: 16px;\n  color: #dc3545;\n  margin-bottom: 12px;\n}\n\n.error-message {\n  background: #2a1a1a;\n  border: 1px solid #dc3545;\n  border-radius: 6px;\n  padding: 12px;\n  color: #ccc;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.retry-button {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 20px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.retry-button:hover {\n  background: #c82333;\n}\n\n/* Processing Animation */\n.processing-animation {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.processing-animation .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #333;\n  border-top: 3px solid #007acc;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.processing-animation p {\n  font-size: 14px;\n  color: #ccc;\n  margin: 0 0 12px 0;\n}\n\n.generation-notice {\n  background: #2a1a1a;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  padding: 12px;\n  margin-top: 16px;\n}\n\n.generation-notice p {\n  font-size: 12px;\n  color: #ffeb3b;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Download Notification */\n.download-notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 10003;\n  max-width: 300px;\n  background: #1a2a1a;\n  border: 1px solid #28a745;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.notification-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n}\n\n.notification-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.notification-icon svg {\n  color: #28a745;\n}\n\n.notification-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-text strong {\n  color: #28a745;\n  font-size: 14px;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.notification-text p {\n  margin: 0;\n  font-size: 13px;\n  color: #ccc;\n  line-height: 1.3;\n}\n\n.notification-close {\n  background: none;\n  border: none;\n  color: #ccc;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.notification-close:hover {\n  color: #fff;\n  background: #333;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .video-generation-modal.minimized {\n    width: calc(100vw - 40px);\n    right: 20px;\n  }\n  \n  .video-generation-modal.expanded {\n    width: 95%;\n    max-height: 90vh;\n  }\n  \n  .modal-content {\n    padding: 20px 16px;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .download-notification {\n    right: 10px;\n    left: 10px;\n    max-width: none;\n  }\n  \n  .minimized-title {\n    font-size: 12px;\n  }\n  \n  .progress-text-mini {\n    font-size: 11px;\n    min-width: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
